<template>
  <div class="verify-process" v-ps>
    <div style="position: relative">
      <el-divider direction="vertical"></el-divider>
      <div v-for="(processItem, index) in processInfo" :key="index" style="margin-top: 10px;">
        <div v-if="processItem.state === '结束'" class="process-item finish">
          <div class="person-avatar">
            <span class="staff">
              <svg-icon class="image" icon-class="detail_finish"></svg-icon>
            </span>
          </div>
          <div class="detail-content">
            <div class="basic-info">
              <div class="person-result">
                <div class="name">{{ processItem.state }}</div>
              </div>
              <div class="time">{{ processItem.createAt.slice(5) }}</div>
            </div>
          </div>
        </div>
        <div
          v-else-if="!(processItem.approval && processItem.approval.length)"
          class="process-item"
        >
          <div class="person-avatar">
            <staff-popover
              :staffId="processItem.user.id"
              class="staff"
              v-if="processItem.state != '已撤回'"
            >
              <template v-slot:reference>
                <staff-avatar class="avatar" :size="36" :user="processItem.user"></staff-avatar>
                <span class="state-icon">
                  <svg-icon
                    :icon-class="processItem.state === '已驳回' ? 'detail_reject' : 'detail_pass'"
                  ></svg-icon>
                </span>
              </template>
            </staff-popover>
            <div class="person-avatar" v-else>
              <span class="staff"></span>
            </div>
          </div>
          <div class="detail-content">
            <div class="basic-info">
              <div class="person-result">
                <div class="name" v-if="processItem.state != '已撤回'">
                  {{ processItem.user.name }}
                </div>
                <div
                  class="detail-result"
                  :style="
                    ['已驳回', '已撤回'].includes(processItem.state)
                      ? 'color: #FD6565;'
                      : 'color: #40d492;'
                  "
                >
                  {{ processItem.state }}
                </div>
              </div>
              <div class="time">{{ processItem.createAt.slice(5) }}</div>
            </div>
            <div
              v-if="!_.isEmpty(processItem.adviceList) && processItem.state != '已撤回'"
              class="advice-list"
            >
              <div v-for="item in processItem.adviceList" :key="item.user.id">
                <div class="process-advice" v-if="item.comment || item.sign">
                  <staff-popover
                    :staffId="item.user.id"
                    placement="top"
                    class="advice-person"
                    :key="index"
                  >
                    <template v-slot:reference>
                      <div class="center">
                        <staff-avatar size="small" :user="item.user"></staff-avatar>
                        <span class="right">
                          {{ item.user.name }}
                        </span>
                      </div>
                    </template>
                  </staff-popover>
                  <span
                    v-html="item.comment"
                    v-viewer="{ backdrop: 'static' }"
                    class="log-html"
                  ></span>
                  <div v-if="item.sign" class="sign">
                    签名：
                    <img :src="item.sign" class="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="process-item">
          <div class="person-avatar">
            <span class="staff" style="padding-bottom: 2px">
              <svg-icon class="image" icon-class="detail_verify"></svg-icon>
              <span class="state-icon">
                <svg-icon :icon-class="verifyStateMap[processItem.state].icon"></svg-icon>
              </span>
            </span>
          </div>
          <div class="detail-content">
            <div class="basic-info">
              <div class="person-result">
                <div class="name">{{ processItem.name }}</div>
                <div
                  class="detail-result"
                  :style="'color:' + verifyStateMap[processItem.state].color"
                >
                  {{ processItem.state }}
                </div>
              </div>
              <div class="time" v-if="processItem.createAt">
                {{ processItem.createAt.slice(5) }}
              </div>
            </div>
            <div class="approval-persons">
              <staff-popover
                v-for="(person, index) in processItem.approval"
                :staffId="person.user.id"
                placement="top"
                style="display: inline-block;"
                :key="index"
              >
                <template v-slot:reference>
                  <div class="center" :class="person.user.id ? 'background-user' : ''">
                    <staff-avatar size="small" :user="person.user"></staff-avatar>
                    <span class="right">
                      {{ person.user.name }}
                    </span>
                    <span class="pass-icon" v-if="person.pass !== null">
                      <svg-icon
                        :icon-class="person.pass ? 'detail_pass' : 'detail_reject'"
                      ></svg-icon>
                    </span>
                  </div>
                </template>
              </staff-popover>
            </div>
            <div v-if="!_.isEmpty(processItem.adviceList)" class="advice-list">
              <div v-for="item in processItem.adviceList" :key="item.user.id">
                <div class="process-advice" v-if="item.comment || item.sign">
                  <staff-popover
                    :staffId="item.user.id"
                    placement="top"
                    class="advice-person"
                    :key="index"
                  >
                    <template v-slot:reference>
                      <div class="center">
                        <staff-avatar size="small" :user="item.user"></staff-avatar>
                        <span class="right">
                          {{ item.user.name }}
                        </span>
                      </div>
                    </template>
                  </staff-popover>
                  <span
                    v-html="item.comment"
                    v-viewer="{ backdrop: 'static' }"
                    class="log-html"
                  ></span>
                  <div v-if="item.sign" class="sign">
                    签名：
                    <img :src="item.sign" class="image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StaffPopover from "@/components/BaseComponents/StaffPopover"
import { verifyStateMap } from "@/components/Sheet/DetailDialog/static"
import StaffAvatar from "@/components/StaffAvatar"

export default {
  name: "VerifyProcess",
  components: { StaffPopover, StaffAvatar },
  props: { processInfo: Array, from: String },
  data() {
    return {
      verifyStateMap
    }
  }
}
</script>

<style lang="scss" scoped>
.verify-process {
  padding-right: 13px;
  padding-bottom: 13px;
  .process-item {
    display: flex;
    align-items: flex-start;
    .detail-content {
      flex: 1;
      margin-left: 10px;
      padding-bottom: 10px;
      border-bottom: 1px solid #eaecf0;
      .basic-info {
        display: flex;
        justify-content: space-between;
        padding-top: 2px;
      }
      .advice-list {
        .process-advice {
          ::v-deep .log-html {
            img {
              width: 235px;
              height: auto;
            }
          }
          display: flex;
          flex-flow: column;
          background-color: #e7eaee;
          border-radius: 6px;
          margin-top: 6px;
          padding: 6px 8px;
          color: #878a90;
          width: 250px;
          box-sizing: border-box;
          overflow: hidden;
          font-size: 13px;
          .advice-person {
            display: flex;
            flex-wrap: wrap;
            .center {
              display: flex;
              align-items: center;
              position: relative;
              margin-bottom: 3px;
              .pass-icon {
                position: absolute;
                font-size: 12px;
                right: -2px;
                bottom: -2px;
              }
            }
            .right {
              margin-left: 3px;
            }
            ::v-deep {
              .el-avatar--small {
                width: 20px;
                height: 20px;
                line-height: 24px;
              }
            }
          }
          ::v-deep {
            p {
              margin: 0;
            }
            ol {
              padding-inline-start: 16px;
            }
            ol li {
              list-style: decimal;
            }
            ul {
              padding-inline-start: 16px;
            }
            ul li {
              list-style: disc;
            }
          }
        }
      }
      .approval-persons {
        display: flex;
        flex-wrap: wrap;
        .center {
          display: flex;
          align-items: center;
          position: relative;
          margin-right: 8px;
          margin-top: 6px;
          .pass-icon {
            position: absolute;
            font-size: 12px;
            right: -2px;
            bottom: -2px;
          }
        }
        .background-user {
          background-color: #e7eaee;
          padding: 2px 10px 2px 4px;
          border-radius: 15px;
        }
        .right {
          color: #313132;
          margin-left: 6px;
        }
        ::v-deep {
          .el-avatar--small {
            width: 24px;
            height: 24px;
            line-height: 26px;
          }
        }
      }
    }
    .time {
      font-size: 12px;
      color: #878a90;
      margin-top: 2px;
    }
  }
  .finish {
    align-items: center;
    .detail-content {
      border: none;
      .basic-info {
        align-items: center;
      }
    }
    .time {
      margin: 0;
    }
  }
  .person-avatar {
    padding-bottom: 10px;
    align-items: center;
    display: flex;
    .staff {
      background-color: #f5f7fa;
      position: relative;
      padding-top: 2px;
      .state-icon {
        font-size: 14px;
        position: absolute;
        right: 0;
        top: 26px;
      }
    }
    .image {
      font-size: 36px;
    }
  }
  .person-result {
    .name {
      font-size: 14px;
      color: #313132;
    }
    .detail-result {
      font-size: 12px;
      margin-top: 1px;
    }
  }
  .el-divider {
    background-color: #c0c4cc;
  }
  ::v-deep {
    .el-divider--vertical {
      margin: 0;
      position: absolute;
      left: 18px;
      height: calc(100% - 20px);
    }
  }
  .result {
    padding: 3px 8px;
    border-radius: 4px;
    font-size: 12px;
  }
  .pass {
    border: 1px solid #40d492;
    color: #40d492;
  }
  .reject {
    border: 1px solid #fd6565;
    color: #fd6565;
  }
  .cancel {
    border: 1px solid #878a90;
    color: #878a90;
  }
  .sign {
    display: flex;
    align-items: center;
    .image {
      width: 40px;
    }
  }
}
</style>
